export const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN;
export const AUTH_DOMAIN = `auth.${DOMAIN}`;
export const APP_URL = process.env.NEXT_PUBLIC_APP_URL;
export const PAYMENTS_API_URL = process.env.NEXT_PUBLIC_PAYMENTS_API_URL;

export const TRADERS_API_URL = process.env.NEXT_PUBLIC_TRADERS_API_URL ?? '';
export const TRADERS_WEBSOCKET_URL =
  process.env.NEXT_PUBLIC_TRADERS_WEBSOCKET_URL ?? '';
